<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'chargeInformation.chargeType' | translate }}</label>
    <select appSelect [collection]="chargeInformationList" formControlName="chargeType"></select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'chargeInformation.chargeTypeId' | translate }}</label>
    <select appSelect [collection]="chargeInformationIdList" formControlName="chargeTypeId">
    </select>
  </app-input-group>

  @if (form.get('chargeType')?.value === 'Subscription') {
    <app-input-group>
      <label appLabel>{{ 'chargeInformation.chargeOccurrences' | translate }}</label>
      <input type="number" appInput formControlName="chargeOccurrences">
    </app-input-group>
  }
  <app-input-group>
    <label appLabel>{{ 'chargeInformation.validFrom' | translate }}</label>
    <input appInputDate formControlName="validFrom">
  </app-input-group>

</form>
